// extracted by mini-css-extract-plugin
export var card = "_ay-1";
export var container = "_ay-0";